<template>
  <div class="profil-container">
    <h3 class="profil-title">Halaman Pengisian Data Vendor</h3>
    <p class="profil-subtitle">Silahkan mengisi data sesuai kolom di bawah</p>

    <div class="vendor-form-wrapper">
      <div class="vendor-form">
        <p class="vendor-form-label">
          Nama Pemilik Rekening<span class="text-ast">*</span>
        </p>
        <input
          type="text"
          class="vendor-input"
          placeholder="NAMA VENDOR"
          v-model="pemilikBank"
          oninput="let p=this.selectionStart;this.value=this.value.toUpperCase();this.setSelectionRange(p, p);"
        />
      </div>

      <!-- <div class="vendor-form">
        <p class="vendor-form-label">Negara Bank<span class="text-ast">*</span></p>
        <select v-model="selectedBankCountry" class="vendor-input">
          <option v-for="(option, index) in countryList" :key="index" :value="option.negara">
            {{ option.negara }}
          </option>
        </select>
      </div> -->

      <!-- <div
        class="vendor-form"
        v-if="$get($store, 'state.landingpage.choosedCountry.id') == 63"
      >
        <p class="vendor-form-label">
          Nama Bank<span class="text-ast">*</span>
        </p>
        <div class="vendor-input">
          <v-select
            class="style-chooser"
            placeholder="Pilih Bank"
            label="desc"
            :options="bankList"
            v-model="selectedBank"
            autocomplete="bank"
          />
        </div>
      </div> -->

      <div class="vendor-form">
        <p class="vendor-form-label">
          Nama Bank<span class="text-ast">*</span>
        </p>
        <input
          type="text"
          class="vendor-input"
          v-model="selectedBankInter"
          oninput="let p=this.selectionStart;this.value=this.value.toUpperCase();this.setSelectionRange(p, p);"
        />
      </div>

      <div class="vendor-form">
        <p class="vendor-form-label">
          Kantor Cabang<span class="text-ast">*</span>
        </p>
        <input
          type="text"
          class="vendor-input"
          v-model="bankBranchOffice"
          oninput="let p=this.selectionStart;this.value=this.value.toUpperCase();this.setSelectionRange(p, p);"
        />
      </div>

      <div class="vendor-form">
        <p class="vendor-form-label">
          Nomor Rekening<span class="text-ast">*</span>
        </p>
        <input type="number" class="vendor-input" v-model="accountNumber" />
        <!-- <the-mask
          class="vendor-input"
          :mask="['#### #### #### #### #### #### ####']"
          v-model="accountNumber"
        /> -->
      </div>

      <div class="vendor-form">
        <div class="vendor-form-label">
          Mata Uang<span class="text-ast">*</span>
        </div>
        <div class="vendor-input">
          <v-select
            class="style-chooser"
            placeholder="Pilih Mata Uang"
            label="kode_mata_uang"
            :options="countryList"
            v-model="mataUang"
            autocomplete="negara"
          />
        </div>
      </div>
      <!-- 
      <div
        class="vendor-form"
        v-if="$get($store, 'state.landingpage.choosedCountry.id') == 63"
      >
        <p class="vendor-form-label">
          Mata Uang<span class="text-ast">*</span>
        </p>
        <input type="text" class="vendor-input" v-model="mataUang" />
      </div> -->

      <div class="vendor-form">
        <p class="vendor-form-label">
          Nomor NPWP<span class="text-ast">*</span>
        </p>
        <the-mask
          class="vendor-input"
          :mask="['##.###.###.#-###.###']"
          placeholder="XX.XXX.XXX.X-XXX.XXX"
          v-model="npwpBank"
        />
      </div>
    </div>

    <div class="profil-btn-wrapper">
      <div @click="goBack()" class="btn-landing">Kembali</div>
      <div @click="goAfiliasi()" class="btn-landing">Selanjutnya</div>
    </div>
  </div>
</template>

<script>
import { api } from '@/services/config'
import axios from 'axios'
export default {
  name: 'bank',
  data() {
    return {
      bankList: [],
      countryList: [],
    }
  },
  created() {
    // this.getBank()
    this.getCountry()
  },
  computed: {
    pemilikBank: {
      get: function() {
        return this.$store.state.landingpage.pemilikBank
      },
      set: function(newValue) {
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'pemilikBank',
          value: newValue,
        })
      },
    },
    selectedBankCountry: {
      get: function() {
        return this.$store.state.landingpage.selectedBankCountry
      },
      set: function(newValue) {
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'selectedBankCountry',
          value: newValue,
        })
      },
    },
    selectedBank: {
      get: function() {
        return this.$store.state.landingpage.selectedBank
      },
      set: function(newValue) {
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'selectedBank',
          value: newValue.desc,
        })
      },
    },
    selectedBankInter: {
      get: function() {
        return this.$store.state.landingpage.selectedBank
      },
      set: function(newValue) {
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'selectedBank',
          value: newValue,
        })
      },
    },
    bankBranchOffice: {
      get: function() {
        return this.$store.state.landingpage.bankBranchOffice
      },
      set: function(newValue) {
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'bankBranchOffice',
          value: newValue,
        })
      },
    },
    accountNumber: {
      get: function() {
        return this.$store.state.landingpage.accountNumber
      },
      set: function(newValue) {
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'accountNumber',
          value: newValue,
        })
      },
    },
    mataUang: {
      get: function() {
        return this.$store.state.landingpage.mataUang
      },
      set: function(newValue) {
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'mataUang',
          value: newValue.kode_mata_uang,
        })
      },
    },
    npwpBank: {
      get: function() {
        return this.$store.state.landingpage.npwpBank
      },
      set: function(newValue) {
        // XX.XXX.XXX.X-XXX.XXX
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'npwpBank',
          value: newValue,
        })
      },
    },
  },
  methods: {
    checkForm() {
      let arr = [
        [this.pemilikBank, 'Nama Pemilik Rekening'],
        [this.$store.state.landingpage.selectedBank, 'Nama Bank'],
        [this.bankBranchOffice, 'Kantor Cabang'],
        [this.accountNumber, 'Nomor Rekening'],
        [this.mataUang, 'Mata Uang'],
      ]

      if (
        this.$get(this.$store, 'state.landingpage.type_pendaftaran_id') == 1
      ) {
        return this.multiConditions(arr)
      }
      return true
    },
    goBack() {
      this.$store.commit('landingpage/SET_LANDINGPAGE_FORM', 'alamat')
    },
    goAfiliasi() {
      if (this.checkForm()) {
        this.$store.commit('landingpage/SET_LANDINGPAGE_FORM', 'afiliasi')
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'afiliasi_step',
          value: true,
        })
      }
    },
    async getBank() {
      try {
        const url = `${api}/api/v1/bank?page=1&limit=100`
        const { data } = await axios({
          method: 'GET',
          url,
        })
        this.bankList = data.data
      } catch (error) {}
    },
    async getCountry() {
      const url = `${api}/api/v1/negara?page=1&limit=1000`
      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })

        this.countryList = data.data
      } catch (error) {}
    },
  },
}
</script>
